(() => {
  document.documentElement.classList.add('ks-js');
  const copy = document.getElementById('ks-language');
  const words = copy ? JSON.parse(copy.textContent) : {};
  const t = key => words[key] || key;
  const libraryCopy = document.getElementById('ks-library-language');
  const ltWords = libraryCopy ? JSON.parse(libraryCopy.textContent) : {};
  const lt = key => ltWords[key] || key;
  const root = document.documentElement.dataset.shopRoot || '/';
  const money = cents => `${new Intl.NumberFormat('ar-MA', {maximumFractionDigits: 2}).format(cents / 100)} ${t('mad')}`;
  const open = id => {
    const dialog = document.getElementById(id);
    if (dialog && !dialog.open) dialog.showModal();
  };
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-open]');
    if (trigger) open(trigger.dataset.open);
    const close = event.target.closest('[data-close]');
    if (close) close.closest('dialog')?.close();
    const zoom = event.target.closest('[data-photo]');
    if (zoom) {
      const gallery = zoom.closest('[data-product-root]');
      const image = gallery?.querySelector('.ks-image-zoom img');
      if (image) { image.removeAttribute('srcset'); image.src = zoom.dataset.photo; }
      const large = document.getElementById(gallery?.dataset.zoomId)?.querySelector('img') || gallery?.nextElementSibling?.querySelector('img');
      if (large) { large.removeAttribute('srcset'); large.src = zoom.dataset.photo; large.closest('dialog').classList.toggle('ks-styled-view', zoom.dataset.original === 'false'); }
      gallery?.querySelectorAll('[data-photo]').forEach(button => button.setAttribute('aria-pressed', String(button === zoom)));
      gallery?.querySelector('.ks-product-main-image')?.classList.toggle('ks-styled-view', zoom.dataset.original === 'false');
      const note = gallery?.querySelector('[data-gallery-note]');
      if(note) note.textContent = lt(zoom.dataset.original === 'false' ? 'styling_note' : 'original_note');
    }
    const size = event.target.closest('[data-variant]');
    if (size) {
      const form = size.closest('.ks-product-form');
      const select = form.querySelector('select[name=id]');
      select.value = size.dataset.variant;
      select.dispatchEvent(new Event('change', {bubbles:true}));
    }
    const reviewSize = event.target.closest('[data-review-size]');
    if (reviewSize) {
      const form = reviewSize.closest('[data-product-form]');
      form.querySelectorAll('[data-review-size]').forEach(button => button.setAttribute('aria-pressed', String(button === reviewSize)));
      form.querySelector('[data-size-feedback]').textContent = `${t('selected')}: ${reviewSize.dataset.reviewSize}`;
    }
    const codVariant = event.target.closest('[data-cod-variant]');
    if (codVariant && !event.defaultPrevented && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
      event.preventDefault();
      const destination = new URL(window.location.href);
      destination.searchParams.set('variant', codVariant.dataset.codVariant);
      window.location.assign(destination.href);
    }
    const focusSize = event.target.closest('[data-focus-size]');
    if (focusSize) {
      const first = document.querySelector('[data-cod-size-picker] a[aria-current=true], [data-cod-size-picker] a, [data-cod-app-container] input:not([type=hidden]), [data-cod-app-container] select, [data-cod-app-container] button, .ks-size-options button');
      first?.scrollIntoView({block:'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      first?.focus({preventScroll:true});
    }
  });
  document.querySelectorAll('dialog').forEach(dialog => {
    dialog.addEventListener('click', event => {if (event.target === dialog) {const box = dialog.getBoundingClientRect();if(event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();}});
    dialog.querySelectorAll('a[href*="#"]').forEach(a => a.addEventListener('click', () => dialog.close()));
  });
  document.querySelectorAll('[data-catalog]').forEach(catalog => {
    const cards = [...catalog.querySelectorAll('[data-shoe]')];
    const styles = [...catalog.querySelectorAll('input[type=radio]')];
    if (!styles.length) return;
    const color = catalog.querySelector('[data-filter-color]');
    const size = catalog.querySelector('[data-filter-size]');
    const sort = catalog.querySelector('[data-sort]');
    const panel = catalog.querySelector('[data-filter-panel]');
    const active = catalog.querySelector('[data-active-filters]');
    const chips = catalog.querySelector('[data-filter-chips]');
    const badge = catalog.querySelector('[data-filter-badge]');
    const desktop = window.matchMedia('(min-width: 801px)');
    const syncPanel = () => { if (panel) panel.open = desktop.matches; };
    syncPanel();
    desktop.addEventListener('change', syncPanel);
    const apply = (updateUrl = true) => {
      const selectedStyle = styles.find(input => input.checked);
      const style = selectedStyle?.value || 'all';
      let count = 0;
      cards.forEach(card => {
        const match = (style === 'all' || card.dataset.category === style) && (color.value === 'all' || card.dataset.color === color.value) && (size.value === 'all' || (card.dataset.sizes || '').split(' ').includes(size.value));
        card.hidden = !match;
        if (match) count++;
      });
      const status = catalog.querySelector('[data-result-count]');
      if (status) status.textContent = `${catalog.dataset.resultLabel}: ${count}`;
      const empty = catalog.querySelector('[data-no-results]');
      if (empty) empty.hidden = count !== 0;
      const ordered = [...cards];
      if (sort.value === 'name') ordered.sort((a,b) => a.dataset.title.localeCompare(b.dataset.title, 'ar'));
      if (sort.value === 'price') ordered.sort((a,b) => Number(a.dataset.price) - Number(b.dataset.price));
      if (sort.value === 'price-desc') ordered.sort((a,b) => Number(b.dataset.price) - Number(a.dataset.price));
      ordered.forEach(card => catalog.querySelector('.ks-product-grid').append(card));
      chips.replaceChildren();
      const filters = [{key:'style', value:style, text:selectedStyle?.nextElementSibling.textContent}, {key:'color', value:color.value, text:color.selectedOptions[0].textContent}, {key:'size', value:size.value, text:size.value}].filter(filter => filter.value !== 'all');
      filters.forEach(filter => {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = `${filter.text} ×`;
        button.setAttribute('aria-label', `${catalog.dataset.removeFilter}: ${filter.text}`);
        button.addEventListener('click', () => {
          if (filter.key === 'style') styles[0].checked = true;
          else if (filter.key === 'color') color.value = 'all';
          else size.value = 'all';
          apply();
        });
        chips.append(button);
      });
      active.hidden = !filters.length;
      const countFilters = Number(color.value !== 'all') + Number(size.value !== 'all');
      badge.hidden = !countFilters;
      badge.textContent = String(countFilters);
      if (updateUrl) {
        const url = new URL(location.href);
        [{key:'style',value:style,base:'all'}, {key:'color',value:color.value,base:'all'}, {key:'size',value:size.value,base:'all'}, {key:'sort',value:sort.value,base:'default'}].forEach(filter => {
          if (filter.value === filter.base) url.searchParams.delete(filter.key);
          else url.searchParams.set(filter.key,filter.value);
        });
        history.replaceState(null,'',url);
      }
    };
    const params = new URLSearchParams(location.search);
    styles.forEach(input => { if (input.value === params.get('style')) input.checked = true; input.addEventListener('change', () => apply()); });
    [[color,'color'],[size,'size'],[sort,'sort']].forEach(([select,key]) => {
      if ([...select.options].some(option => option.value === params.get(key))) select.value = params.get(key);
      select.addEventListener('change', () => apply());
    });
    catalog.querySelectorAll('[data-reset-filters]').forEach(button => button.addEventListener('click', () => {styles[0].checked = true; color.value = 'all'; size.value = 'all'; sort.value = 'default'; apply();}));
    apply(false);
  });
  document.querySelectorAll('[data-search-preview]').forEach(area => {
    const terms=area.dataset.searchQuery.toLowerCase().trim().split(/\s+/).filter(Boolean);
    let count=0;
    area.querySelectorAll('[data-shoe]').forEach(card => {const text=(card.textContent+' '+card.dataset.category).toLowerCase();card.hidden=!terms.every(term=>text.includes(term));if(!card.hidden)count++;});
    area.querySelector('[data-search-count]').textContent=count+' '+t('result_count');
  });
  const showCart = async () => {
    const response = await fetch(`${root}cart.js`, {headers:{Accept:'application/json'}});
    if (!response.ok) throw new Error(t('cart_error'));
    const cart = await response.json();
    document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
    const area = document.querySelector('[data-cart-lines]');
    area.replaceChildren();
    cart.items.forEach(item => {
      const article = document.createElement('article');article.className='ks-drawer-item';
      const image=document.createElement('img');image.src=item.image;image.alt=item.product_title;image.width=90;image.height=90;
      const info=document.createElement('div');const title=document.createElement('h3');title.textContent=item.product_title;
      const details=document.createElement('p');details.textContent=`${item.variant_title} · ${t('quantity')} ${item.quantity}`;
      const price=document.createElement('p');price.textContent=money(item.final_line_price);
      info.append(title,details,price);article.append(image,info);area.append(article);
    });
    document.querySelector('[data-cart-total]').textContent=money(cart.total_price);
    document.querySelector('[data-cart-status]').textContent=t('added');
    open('ks-cart');
  };
  const helpDialog = document.getElementById('ks-purchase-help');
  const helpCopy = document.getElementById('ks-help-language');
  const helpWords = helpCopy ? JSON.parse(helpCopy.textContent) : {};
  const helpMessage = helpDialog?.querySelector('#ks-help-message');
  const updateHelpLink = () => {
    const link = helpDialog?.querySelector('[data-help-whatsapp]');
    if (!link) return;
    try {
      const url = new URL(link.dataset.baseUrl);
      if (!['wa.me', 'api.whatsapp.com'].includes(url.hostname) || url.protocol !== 'https:') { link.hidden = true; return; }
      const context = helpDialog.querySelector('[data-help-context]').value;
      url.searchParams.set('text', [helpMessage.value, context].filter(Boolean).join('\n'));
      link.href = url.href;
    } catch { link.hidden = true; }
  };
  const chooseHelpTopic = topic => {
    helpDialog?.querySelectorAll('[data-help-topic]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.helpTopic === topic)));
    if (helpMessage && (!helpMessage.value || Object.values(helpWords).includes(helpMessage.value))) helpMessage.value = helpWords[topic] || helpWords.product || '';
    updateHelpLink();
  };
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-purchase-help]');
    if (trigger && helpDialog) {
      const product = document.querySelector('[data-product-root]');
      const codSize = product?.querySelector('.ks-cod-real-sizes [data-cod-variant][aria-current="true"]')?.dataset.sizeTitle;
      const size = codSize || product?.querySelector('[data-review-size][aria-pressed="true"]')?.dataset.reviewSize || product?.querySelector('select[name="id"] option:checked')?.textContent;
      const context = product ? [product.dataset.title, product.dataset.color, size && (codSize || product.querySelector('select[name="id"]')?.value !== '') ? `${helpWords.selected}: ${size.trim()}` : helpWords.no_size].filter(Boolean).join(' · ') : '';
      helpDialog.querySelector('[data-help-context]').value = context;
      helpDialog.querySelector('[data-help-context-wrap]').hidden = !context;
      chooseHelpTopic(trigger.dataset.helpRequest || 'product');
      document.querySelectorAll('dialog[open]').forEach(dialog => { if (dialog !== helpDialog) dialog.close(); });
      open('ks-purchase-help');
    }
    const topic = event.target.closest('[data-help-topic]');
    if (topic) chooseHelpTopic(topic.dataset.helpTopic);
  });
  helpMessage?.addEventListener('input', updateHelpLink);
  if (helpDialog?.querySelector('[data-help-result]')) open('ks-purchase-help');

  const node = (tag, text, className) => {
    const el = document.createElement(tag);
    if(text !== undefined) el.textContent = text;
    if(className) el.className = className;
    return el;
  };
  const safeLink = value => {
    try {const url = new URL(value, location.origin); return url.origin === location.origin ? url.href : null;} catch {return null;}
  };
  const safeImage = value => {
    try {const url = new URL(value, location.href);return url.origin === location.origin || url.hostname === 'cdn.shopify.com' ? url.href : null;}catch{return null;}
  };
  const validEntry = item => item && typeof item.key === 'string' && item.key && typeof item.title === 'string' && safeLink(item.url) && safeImage(item.image) && Number.isFinite(Number(item.price));
  const readStore = key => {
    try {const data = JSON.parse(localStorage.getItem(key) || '[]');return Array.isArray(data) ? data.filter(validEntry).slice(0,24) : [];}catch{return [];}
  };
  const writeStore = (key,data) => {
    try {localStorage.setItem(key,JSON.stringify(data));return true;}catch{return false;}
  };
  const entryFor = el => {
    const d = el.dataset;
    const color = d.color || (['أسود','بني','بيج','عسلي'].find(value => d.title?.includes(value)) || lt('unknown'));
    return {key:d.key,title:d.title,url:d.url,image:d.image,category:d.category,color,price:Number(d.price)};
  };
  let saved = readStore('korva.saved.v1');
  let compared = [];
  let recent = readStore('korva.recent.v1');
  const currentNode = document.querySelector('[data-library-product]');
  const current = currentNode ? entryFor(currentNode) : null;
  if(validEntry(current)){recent=[current,...recent.filter(item => item.key !== current.key)].slice(0,12);writeStore('korva.recent.v1',recent);}
  const styleName = item => ({Mocassin:lt('moccasins'),Basket:lt('sneakers'),Derby:lt('derby'),Richelieu:lt('richelieu'),Bottine:lt('boots')})[item.category] || item.category || lt('unknown');
  const notify = message => {
    const status=document.querySelector('[data-library-status]');if(!status)return;
    status.textContent=message;status.classList.add('ks-show-toast');
    window.clearTimeout(notify.timer);notify.timer=window.setTimeout(()=>status.classList.remove('ks-show-toast'),3000);
  };
  const removeButton = (item,type) => {
    const button=node('button',lt('remove'),'ks-text-link');button.type='button';button.dataset.removeKey=item.key;button.dataset.removeType=type;button.setAttribute('aria-label',`${lt('remove')} ${item.title}`);return button;
  };
  const renderSaved = () => {
    const list=document.querySelector('[data-saved-list]');if(!list)return;list.replaceChildren();
    saved.forEach(item=>{
      const row=node('article',undefined,'ks-saved-item');
      const a=node('a');a.href=safeLink(item.url);const im=node('img');im.src=safeImage(item.image);im.alt=item.title;im.width=96;im.height=96;im.loading='lazy';a.append(im);
      const info=node('div');const title=node('a',item.title);title.href=safeLink(item.url);info.append(title,node('p',money(item.price)),removeButton(item,'saved'));row.append(a,info);list.append(row);
    });
    document.querySelector('[data-saved-empty]').hidden=saved.length>0;
  };
  const renderCompare = () => {
    const area=document.querySelector('[data-compare-content]');if(!area)return;area.replaceChildren();
    if(!compared.length){area.append(node('p',lt('empty_compare')));return;}
    const scroll=node('div',undefined,'ks-compare-scroll');scroll.tabIndex=0;const table=node('table',undefined,'ks-compare-table');
    const head=node('thead');const row=node('tr');const corner=node('th');corner.scope='col';corner.textContent=lt('style');row.append(corner);
    compared.forEach(item=>{const cell=node('th');cell.scope='col';const image=node('img');image.src=safeImage(item.image);image.alt=item.title;image.width=240;image.height=240;cell.append(image,node('h3',item.title),removeButton(item,'compare'));row.append(cell);});head.append(row);table.append(head);
    const body=node('tbody');
    const rows=[['price',item=>money(item.price)],['style',styleName],['color',item=>item.color],['closure',item=>['Mocassin','Bottine'].includes(item.category)?lt('slip_on'):['Basket','Derby','Richelieu'].includes(item.category)?lt('laces'):lt('unknown')],['sizes',()=> '39 — 45']];
    rows.forEach(([label,value])=>{const tr=node('tr');const th=node('th',lt(label));th.scope='row';tr.append(th);compared.forEach(item=>tr.append(node('td',value(item))));body.append(tr);});
    const links=node('tr');const label=node('th',lt('view'));label.scope='row';links.append(label);compared.forEach(item=>{const td=node('td');const a=node('a',lt('view')+' ↗','ks-text-link');a.href=safeLink(item.url);td.append(a);links.append(td);});body.append(links);table.append(body);scroll.append(table);area.append(scroll);
  };
  const syncLibrary = () => {
    document.querySelectorAll('[data-library-ui]').forEach(el=>el.hidden=false);
    document.querySelectorAll('[data-shoe],[data-library-product]').forEach(el=>{
      const key=el.dataset.key;
      el.querySelectorAll('[data-save]').forEach(button=>{const selected=saved.some(item=>item.key===key);button.setAttribute('aria-pressed',String(selected));button.setAttribute('aria-label',lt(selected?'saved':'save'));if(!button.querySelector('svg'))button.textContent=lt(selected?'saved':'save');});
      el.querySelectorAll('[data-compare]').forEach(button=>{const selected=compared.some(item=>item.key===key);button.setAttribute('aria-pressed',String(selected));button.textContent=lt(selected?'compare_added':'compare_add');});
    });
    const bar=document.querySelector('[data-compare-bar]');if(bar){bar.hidden=compared.length===0;bar.querySelector('[data-compare-count]').textContent=`${compared.length} ${lt('compare_count')}`;bar.querySelector('[data-open]').disabled=compared.length<2;}
    renderSaved();renderCompare();
  };
  const recentArea=document.querySelector('[data-recent-list]');
  if(recentArea){const realProductPage=currentNode?.dataset.preview==='false';const picks=recent.filter(item=>item.key!==current?.key && (!realProductPage || new URL(safeLink(item.url),location.origin).pathname.startsWith('/products/'))).slice(0,4);picks.forEach(item=>{const article=node('article',undefined,'ks-card');const a=node('a',undefined,'ks-card-image');a.href=safeLink(item.url);const image=node('img');image.src=safeImage(item.image);image.alt=item.title;image.width=500;image.height=500;image.loading='lazy';a.append(image);const meta=node('div',undefined,'ks-card-meta');meta.append(node('span',styleName(item)),node('span',money(item.price)));const title=node('h3');const link=node('a',item.title);link.href=safeLink(item.url);title.append(link);article.append(a,meta,title);recentArea.append(article);});recentArea.closest('[data-recent-section]').hidden=!picks.length;}
  document.addEventListener('click',event=>{
    const saveButton=event.target.closest('[data-save]');const compareButton=event.target.closest('[data-compare]');
    if(saveButton||compareButton){const el=(saveButton||compareButton).closest('[data-shoe],[data-library-product]');const item=el?entryFor(el):null;if(!validEntry(item))return;
      if(saveButton){saved=saved.some(x=>x.key===item.key)?saved.filter(x=>x.key!==item.key):[item,...saved].slice(0,24);if(!writeStore('korva.saved.v1',saved))notify(lt('storage_error'));}
      else if(compared.some(x=>x.key===item.key))compared=compared.filter(x=>x.key!==item.key);
      else if(compared.length<3)compared.push(item);
      else notify(lt('compare_limit'));
      syncLibrary();
    }
    const remove=event.target.closest('[data-remove-key]');if(remove){if(remove.dataset.removeType==='saved'){saved=saved.filter(x=>x.key!==remove.dataset.removeKey);if(!writeStore('korva.saved.v1',saved))notify(lt('storage_error'));}else compared=compared.filter(x=>x.key!==remove.dataset.removeKey);syncLibrary();}
    if(event.target.closest('[data-clear-compare]')){compared=[];syncLibrary();}
  });
  window.addEventListener('storage',event=>{if(event.key==='korva.saved.v1'){saved=readStore('korva.saved.v1');syncLibrary();}});
  syncLibrary();

  document.addEventListener('shopify:section:load',() => location.reload());
})();
